<div
  class="app-container"
  [class.mobile]="isHandsetAndPortrait()">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      class="sidenav"
      #sidenav
      [mode]="isHandsetAndPortrait() ? 'over' : 'side'"
      [opened]="!isHandsetAndPortrait()"
      [disableClose]="!isHandsetAndPortrait()">
      @if (isHandsetAndPortrait()) {
        <button
          type="button"
          mat-icon-button
          (click)="sidenav.close()"
          aria-label="Close Navigation Drawer"
          data-cy="close-nav-drawer-button">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      }
      <mat-nav-list
        class="nav-list"
        disableRipple>
        @for (item of menuItems; track item) {
          <a
            mat-list-item
            class="nav-item"
            [routerLink]="item.routerLink"
            routerLinkActive="active"
            (click)="sidenav.mode === 'over' && sidenav.opened ? sidenav.close() : ''">
            <mat-icon
              matListItemIcon
              [svgIcon]="item.icon"></mat-icon>
            <span class="label">{{ item.label }}</span>
          </a>
        }
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="sidenav-content">
      <mat-toolbar class="app-bar">
        <div class="app-brand-content">
          @if (isHandsetAndPortrait()) {
            <button
              class="sidebar-toggle"
              mat-icon-button
              (click)="sidenav.toggle()">
              <mat-icon svgIcon="menu"></mat-icon>
            </button>
          }
          <img
            class="brand-mark"
            [src]="brandMark() | psuCdn"
            alt="Penn State Mark" />

          <div class="header-container">
            <h1 class="app-name">Fortress</h1>
            <router-outlet name="toolbar"></router-outlet>
          </div>
        </div>
        <app-fortress-search class="search-container"></app-fortress-search>
      </mat-toolbar>
      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
